module.exports = __webpack_public_path__ + "img/f8-1.693ccb95.png";